import { render, staticRenderFns } from "./ProductsAdmin.vue?vue&type=template&id=e3e8f150&scoped=true"
import script from "./ProductsAdmin.vue?vue&type=script&lang=js"
export * from "./ProductsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e8f150",
  null
  
)

export default component.exports